import { Injectable } from '@angular/core';
import * as shajs from 'sha.js';
import { AuctionView, CartView } from 'src/app/articles-manager/interfaces/auction.interface';
import { environment } from 'src/environments/environment';


declare let gtag: Function;
declare let fbq: Function;

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  constructor() {
  }

  trackLogin(){
    if(!environment.production) return;
    gtag('event', 'login', {
      'event_category': 'login',
      'event_label': 'login',
      'value': 'login'
    });

  }

  trackSearch(q: string){
    if(!environment.production) return;
    if((q?.length??0)>0){
      gtag('event', 'search', {
        'search_term': q
      });

      fbq(
        'track',
        'Search',
        {
          search_string: q
        }
      )
    }
  }

  trackBid(idAuction: number, amount: number, eventSlug: string = null) {
    if(!environment.production) return;
    gtag('event', 'bid', {
      'item_id': idAuction.toString(),
      'currency': 'EUR',
      'value': amount,
      'event_slug': eventSlug
    });

    fbq(
      'track',
      'AddToCart',
      {
        content_ids: [idAuction],
        content_type: 'product',
        currency: 'EUR',
        value: amount
      }
    )
  }

  trackViewItem(auction: AuctionView) {

    if(!environment.production) return;
    if(!auction) return;

    gtag("event", "view_item", {
      currency: "EUR",
      value: auction.currentMaxOfferedPrice ?? auction.basePrice,
      items: [
        {
          item_id: auction.idAuction,
          item_name: auction.title,
          item_brand: "Memorabid",
          item_category: auction.articleProperties?.[0],
          item_category2: auction.articleProperties?.[1],
          item_category3: auction.articleProperties?.[2],
          price: auction.currentMaxOfferedPrice ?? auction.basePrice
        }
      ]
    });

    fbq(
      'track',
      'ViewContent',
      {
         content_ids: [auction.idAuction],
          content_name: auction.title,
          content_type: 'product',
          currency: 'EUR',
          value: auction.currentMaxOfferedPrice ?? auction.basePrice
      }
    )

  }

  trackSignUp(status: 'registered' | 'active' ){
    if(!environment.production) return;
    gtag('event', 'sign_up', {
      'event_category': 'sign_up',
      'event_label': 'sign_up',
      'value': 'sign_up',
      'status': status
    });

    fbq(
      status === 'registered' ? 'track' : 'trackCustom',
      status === 'registered' ? 'CompleteRegistration' : 'ActivatedAccount',
      {
        value: 'sign_up',
        status
      }
    )

  }

  trackInit(user: {
    idUser: number,
    email: string,
    firstName: string,
    lastName: string,

  }){
    if(!environment.production) return;

    const hashedEmail = shajs('sha256').update(user.email.toLowerCase()).digest('hex');

    gtag('set', 'user_id', user.idUser);

    fbq(
      'init',
      environment.facebookPixelId,
      {
        em: hashedEmail,
        fn: user.firstName.toLocaleLowerCase(),
        ln: user.lastName.toLocaleLowerCase(),
        external_id: user.idUser,

      }
    )

  }

  trackCheckout({auctionPaymentViews, total}: CartView){
    if(!environment.production) return;
    if(!auctionPaymentViews) return;

    gtag('event', 'begin_checkout', {
      currency: "EUR",
      value: total,
      items: auctionPaymentViews.map(a => ({
        item_id: a.auction.idAuction,
        item_name: a.auction.title,
        item_brand: "Memorabid",
        item_category: a.auction.articleProperties?.[0],
        item_category2: a.auction.articleProperties?.[1],
        item_category3: a.auction.articleProperties?.[2],
        price: a.auction.winnerPrice
      }))
    });

    fbq(
      'track',
      'InitiateCheckout',
      {
        content_ids: auctionPaymentViews.map(a => a.auction.idAuction),
        content_name: auctionPaymentViews.map(a => a.auction.title),
        content_type: 'product',
        currency: 'EUR',
        value: total
      }
    )

  }

    trackPaymentMethod({auctionPaymentViews, total, shippingCostTotal, insurancesTotal}: CartView, paymentMethod: string){
    if(!environment.production) return;
    if(!auctionPaymentViews) return;

    gtag("event", "add_payment_info", {
      currency: "EUR",
      value: total - shippingCostTotal,
      shipping: shippingCostTotal,
      items: auctionPaymentViews.map(a => ({
        item_id: a.auction.idAuction,
        item_name: a.auction.title,
        item_brand: "Memorabid",
        item_category: a.auction.articleProperties?.[0],
        item_category2: a.auction.articleProperties?.[1],
        item_category3: a.auction.articleProperties?.[2],
        price: a.auction.winnerPrice,
        quantity: 1
      })),
      payment_method: paymentMethod

    })

  }


  trackPurchase({auctionPaymentViews, total, shippingCostTotal, insurancesTotal, ...cart}: CartView){
    if(!environment.production) return;
    if(!auctionPaymentViews) return;

    gtag("event", "purchase", {
      transaction_id: cart.guidPayment,
      value: total - shippingCostTotal,
      shipping: shippingCostTotal,
      currency: "eur",
      items: auctionPaymentViews.map(a => ({
        item_id: a.auction.idAuction,
        item_name: a.auction.title,
        item_brand: "Memorabid",
        item_category: a.auction.articleProperties?.[0],
        item_category2: a.auction.articleProperties?.[1],
        item_category3: a.auction.articleProperties?.[2],
        price: a.auction.winnerPrice,
        quantity: 1
      }))


  });

    fbq(
      'track',
      'Purchase',
      {
        content_ids: auctionPaymentViews.map(a => a.auction.idAuction),
        content_name: auctionPaymentViews.map(a => a.auction.title),
        content_type: 'product',
        currency: 'EUR',
        value: total
      }
    )

  }
}
